<script>
import format from 'date-fns/format'
import parse from 'date-fns/parse'

export default {
  methods: {
    getFormattedDate(inputDate, doParsing) {
      const input = doParsing ? parse(inputDate) : inputDate
      return inputDate ? format(input, 'DD.MM.YYYY') : ''
    },
    getFormattedDateTime(isoString) {
      return isoString ? format(isoString, 'DD.MM.YYYY hh:mm') : ''
    },
  },
}
</script>
